import { apiRequests } from '../utilities/axios-factory'
import store from '../store'

function authHeaders () {
  return { Authorization: store.getters.getTokenId }
}

function buildSearchParams ({
  agentProfileId,
  dateFrom,
  dateTo,
  searchPhone,
  logTypes,
  orderBy,
  sortOrder,
  page,
  limit
}) {
  const params = { agentProfileId }

  if (dateFrom) {
    params.dateFrom = dateFrom
  }
  if (dateTo) {
    params.dateTo = dateTo
  }
  if (searchPhone) {
    params.searchPhone = searchPhone
  }
  if (logTypes && logTypes.length) {
    params.logTypes = Array.isArray(logTypes) ? logTypes.join(',') : logTypes
  }
  if (orderBy) {
    params.orderBy = orderBy
  }
  if (sortOrder) {
    params.sortOrder = sortOrder
  }
  if (page) {
    params.page = page
  }
  if (limit) {
    params.limit = limit
  }

  return params
}

function searchAgentTransactionLogs (options) {
  return apiRequests.get('/v1/agent-transaction-log/search/', {
    params: buildSearchParams(options),
    headers: authHeaders()
  }).then((result) => {
    return result.data
  })
}

function countAgentTransactionLogs (options) {
  return apiRequests.get('/v1/agent-transaction-log/search/count/', {
    params: buildSearchParams(options),
    headers: authHeaders()
  }).then((result) => {
    return result.data && typeof result.data.count === 'number' ? result.data.count : 0
  })
}

export {
  searchAgentTransactionLogs,
  countAgentTransactionLogs
}
